// extracted by mini-css-extract-plugin
module.exports = {"img":"MlSpaceArticleSlide_img__O6M9b","imgWrapper":"MlSpaceArticleSlide_imgWrapper___qLkB","title":"MlSpaceArticleSlide_title__O1uJ9"};